import moment from 'moment';

export const calcTimeDiff = (
  timeStr1: string | null | undefined,
  timeStr2: string | null | undefined,
  unit: moment.unitOfTime.Diff = 'seconds'
) => {
  if (!timeStr1 || !timeStr2) {
    return undefined;
  }
  return moment(timeStr1).diff(moment(timeStr2), unit, true);
};

/**
 * Converts a date string to a timestamp, returning 0 for null/undefined/invalid dates
 * @param dateString - The date string to convert
 * @returns timestamp in milliseconds, or 0 for invalid/null dates
 */
export const getTimestamp = (dateString: string | undefined): number => {
  if (!dateString) return 0;
  const timestamp = new Date(dateString).getTime();
  return isNaN(timestamp) ? 0 : timestamp;
};

export const formatDate = (date: Date | null | undefined): string => {
  if (!date) return '';
  return moment(date).format('L');
};
